import { render, staticRenderFns } from "./LeadView.vue?vue&type=template&id=681c9c31&"
import script from "./LeadView.vue?vue&type=script&lang=js&"
export * from "./LeadView.vue?vue&type=script&lang=js&"
import style0 from "./LeadView.vue?vue&type=style&index=0&id=681c9c31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports